import Order from "./Order";

class Attendee {
    attendee_id;
    fullName;
    email;
    phoneNumber;
    age;
    birthDate;
    gender;
    isMinor;
    attachment;
    responsibilityLetter;
    order;
    status;

    constructor(obj = {id: null, fullName: null, email: null, phoneNumber: null, age: null, birthDate: null, gender: null}){
        this.attendee_id = obj.id;
        this.fullName = obj.fullName;
        this.email = obj.email;
        this.phoneNumber = obj.phoneNumber;
        this.age = obj.age;
        this.birthDate = obj.birthDate ?? null;
        this.gender = obj.gender ?? null;
        this.isMinor = obj.isMinor ?? false;
        this.attachment = obj.attachment ?? null;
        this.responsibilityLetter = obj.responsibilityLetter ?? null;
    }

    static fromJSON(json) {
        let tmp = new Attendee();
        tmp.attendee_id = json.id ?? null;
        if(json.fullName) {
            tmp.fullName = json.fullName;
        }else if(json.full_name) {
            tmp.fullName = json.full_name;
        } else {
            tmp.fullName = null;
        }
        if(json.phoneNumber) {
            tmp.phoneNumber = json.phoneNumber;
        }else if(json.phone_number) {
            tmp.phoneNumber = json.phone_number;
        } else {
            tmp.phoneNumber = null;
        }
        tmp.email = json.email ?? null;
        tmp.phoneNumber = json.phoneNumber ?? json.phone_number ?? null;
        tmp.age = json.age ?? null;
        tmp.birthDate = json.birthDate ?? json.birth_date ?? null;
        tmp.gender = json.gender ?? null;
        tmp.isMinor = json.isMinor ?? json.is_minor ?? false;
        tmp.order = json.order ? Order.fromJson(json.order) : null;
        tmp.status = json.status != null ? Number(json.status) : null;


        return tmp;
    }
}

export default Attendee;